var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"v-header"},[_c('span',[_c('v-title-bg',[_vm._v("More Inno System")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }